/* A product's Resources (FEHome.dc.html's section, POYT.dc.html's, in the product's look): the
   heading and tabs over a rule, the tab's note on the right, the items 3 to a row. */
.rs { border-radius: 16px; border: 1px solid var(--pp-rule); overflow: hidden; background: var(--pp-card); }
.pp--fe .rs { background: transparent; }
.rs-head { padding: 24px 28px 0; display: flex; align-items: flex-end; justify-content: space-between; gap: 24px; border-bottom: 1px solid var(--pp-rule); }
.rs-head-main { display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.rs-h { margin: 0; font-family: var(--pp-head-font); font-weight: var(--pp-heading-weight); font-size: 26px; letter-spacing: -0.01em; }
.pp--fe .rs-h { font-size: 32px; letter-spacing: 0.02em; text-transform: uppercase; }
/* Where the tabs don't all fit on 1 line (a phone, or POYT's 5 between a phone and a laptop) they
   wrap onto the next, so no tab sits past the edge with nothing to say it's there (Adam's walkthrough,
   9 Oct: POYT's Tools and Bonuses were off the side of an iPhone). On a laptop they fit on 1 line, as
   the boards draw them. The sideways scroll is only a last resort, for 1 tab wider than the strip. */
.rs-tabs { display: flex; flex-wrap: wrap; column-gap: 30px; row-gap: 4px; overflow-x: auto; scrollbar-width: none; }
.pp--poyt .rs-tabs { column-gap: 28px; }
.rs-tabs::-webkit-scrollbar { display: none; }
.rs-tab {
  padding: 8px 0 12px; border: none; border-bottom: 3px solid transparent; background: none; color: var(--pp-soft);
  font-weight: 700; font-size: 15px; display: flex; gap: 8px; align-items: center; white-space: nowrap;
}
.pp--poyt .rs-tab { font-weight: 600; gap: 7px; }
.rs-tab--on { border-bottom-color: var(--pp-nav-on); color: var(--pp-ink); }
.rs-tab-count { font-weight: 600; color: var(--pp-soft); }
.pp--poyt .rs-tab-count { font-weight: 500; }
.rs-note { padding-bottom: 14px; font-size: 14px; line-height: 1.5; color: var(--pp-soft); max-width: 360px; text-align: right; }
.rs-note--phone { margin: 0; padding: 14px 16px 0; text-align: left; max-width: none; }
.rs-video { padding: 22px 28px 0; }
.rs-grid { padding: 22px 28px 26px; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 14px; }
.rs-card {
  display: flex; flex-direction: column; justify-content: space-between; align-items: flex-start; gap: 14px; padding: 18px;
  border-radius: 12px; background: var(--rp-row, var(--pp-card)); border: 1px solid var(--pp-rule);
}
.pp--fe .rs-card { background: var(--fe-surface); border-color: var(--on-dark-10); }
.pp--poyt .rs-card { background: var(--pp-card); }
.rs-card--locked, .pp--fe .rs-card--locked { background: transparent; }
.pp--poyt .rs-card--locked { background: var(--poyt-paper); }
.pp--fe .rs-card--locked { opacity: 0.75; }
.rs-card-top { display: flex; align-items: flex-start; gap: 12px; min-width: 0; }
.rs-icon { width: 38px; height: 38px; border-radius: 9px; background: var(--pp-tint); color: var(--pp-accent); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.pp--poyt .rs-icon { color: var(--poyt-navy); }
.pp--poyt .rs-card--locked .rs-icon { background: var(--poyt-rule); }
.pp--master .rs-icon { color: var(--shell-ink); }
.rs-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.rs-title { font-family: var(--pp-body-font); font-size: 15px; font-weight: 700; line-height: 1.35; }
.pp--poyt .rs-title, .pp--acc .rs-title { font-family: var(--pp-head-font); }
.rs-meta { font-size: 13px; line-height: 1.5; color: var(--pp-soft); }
.rs-meta--new { color: var(--pp-accent); font-weight: 600; }
.pp--acc .rs-meta--new { color: var(--acc-green-2); }
.rs-life {
  align-self: flex-start; margin-top: 2px; height: 22px; padding: 0 8px; border-radius: 11px; border: 1px solid var(--pp-accent);
  color: var(--pp-ink); font-size: 12px; font-weight: 600; display: flex; align-items: center;
}
.pp--poyt .rs-life { color: var(--poyt-navy); }
.rs-when { font-size: 13px; font-weight: 600; color: var(--pp-when); }
.rs-btn {
  height: 38px; padding: 0 14px; border-radius: 8px; border: 1px solid var(--pp-btn-bg); background: var(--pp-btn-bg);
  font-weight: 700; font-size: 14px; display: inline-flex; align-items: center; text-decoration: none; white-space: nowrap;
}
.pp .rs-btn { color: var(--pp-btn-fg); }
.pp--fe .rs-btn { border-color: transparent; }
.pp--poyt .rs-btn { font-weight: 600; }
.pp .rs-btn--done { background: transparent; border-color: var(--rp-line-accent, var(--pp-rule)); color: var(--pp-accent); }
.pp--poyt .rs-btn--done { background: var(--shell-bg); border-color: var(--poyt-done-line); color: var(--poyt-navy); }
.pp--master .rs-btn--done { color: var(--shell-ink); }
.rs .pp-res-act { align-items: flex-start; }
.rs .pp-res-line { text-align: left; }
.rs-foot { margin: 0; padding: 0 28px 22px; font-size: 13px; line-height: 1.5; color: var(--pp-soft); }

@media (max-width: 1099px) {
  .rs-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 760px) {
  .rs { border-radius: 14px; }
  .rs-head { padding: 18px 16px 0; }
  .pp--fe .rs-h, .rs-h { font-size: 24px; }
  .rs-tabs { column-gap: 22px; }
  .rs-tab { font-size: 14px; }
  .rs-video { padding: 16px 16px 0; }
  .rs-grid { grid-template-columns: minmax(0, 1fr); padding: 16px; gap: 12px; }
  .rs-foot { padding: 0 16px 18px; }
}

/* Once their access has ended (Adam, 3 Oct): the line under the heading saying what's left is theirs */
.rs-intro { margin: 0; padding: 18px 28px 0; font-size: 15px; line-height: 1.55; color: var(--pp-soft); }
@media (max-width: 760px) {
  .rs-intro { padding: 14px 16px 0; font-size: 14px; }
}

/* The note and the product's terms link on the right of the tabs (Accelerator.dc.html: "The Property
   Accelerator terms and conditions", underlined, in the soft ink); under the tabs on a phone */
.rs-side { padding-bottom: 14px; display: flex; flex-direction: column; align-items: flex-end; gap: 6px; min-width: 0; }
.rs-side .rs-note { padding-bottom: 0; }
.rs-terms { font-size: 14px; line-height: 1.5; text-decoration: underline; text-align: right; }
.pp .rs-terms { color: var(--pp-soft); }
.pp .rs-terms:hover { color: var(--pp-ink); }
.rs-terms--phone { display: block; margin: 0; padding: 12px 16px 0; text-align: left; }
